<script setup>
import { useAnalysisStore } from '@/store/modules/analysis';

import OhaengChart from '@/components/saju/OhaengChart.vue';
//import FiveStartGuideComponent from '@/components/saju/FiveStartGuideComponent.vue'
import FiveStartMyComponent from '@/components/saju/FiveStartMyComponent.vue';

import IconArrow05 from '@/components/svg/IconArrow05.vue';
import IconStop from '@/components/svg/IconStop.vue';
import IconPause from '@/components/svg/IconPause.vue';
import IconStart from '@/components/svg/IconStart.vue';
import { getDetail } from '@/api/UserGroup';
import { splitToSkyEarth, splitToSkyEarthKor } from '@/utils/sajuUtil';

import { defineProps } from 'vue';
const props = defineProps({
  birthData: {
    type: Object,
  },
  birthEightTxt: {
    type: String,
  },
  selectedDescNavSub: {
    type: String,
    default: 'first',
  },
  guestUserId: {
    type: Object,
  },
  langMode: {
    type: String,
    default: 'chnkor',
  },
});

const store = useAnalysisStore();

const indexNo = ref(1);

const rootPage = ref('analysis');

const pageMode = ref('ani');

const classes = ['five-thu', 'five-tue', 'five-sat', 'five-fri', 'five-wed', 'finishendend'];
const currentClass = ref(''); // 현재 활성화된 클래스
const activeClasses = ref([]); // 활성화된 클래스들의 배열
const currentStep = ref(0); // 현재 애니메이션 단계 (0부터 시작)
const totalSteps = ref(classes.length); // 전체 애니메이션 단계 수
const isAnimating = ref(false); // 애니메이션 진행 중 여부
let index = 0;
let intervalId = null; // 애니메이션을 위한 interval ID

// birthDataSkyEarth에서 매칭되는 글자들을 기반으로 활성화할 클래스들을 결정
const getActiveClassesFromData = () => {
  if (!birthDataSkyEarth.value || !Array.isArray(birthDataSkyEarth.value)) {
    return [];
  }

  const activeClassesList = [];

  // birthDataSkyEarth의 각 글자들을 확인하여 매칭되는 five 클래스들을 찾음
  console.log('🔍 birthDataSkyEarth 데이터:', birthDataSkyEarth.value);

  birthDataSkyEarth.value.forEach((item, index) => {
    if (item.sky) {
      // FiveStartMyComponent의 isCharMatched 로직을 참고하여 매칭되는 클래스 결정
      // 각 오행별로 매칭되는 글자들을 확인
      if (['甲', '乙', '寅', '卯'].includes(item.sky)) {
        if (!activeClassesList.includes('five-thu')) {
          activeClassesList.push('five-thu'); // 목
        }
      }
      if (['丙', '丁', '巳', '午'].includes(item.sky)) {
        if (!activeClassesList.includes('five-tue')) {
          activeClassesList.push('five-tue'); // 화
        }
      }
      if (['戊', '己', '辰', '戌', '丑', '未'].includes(item.sky)) {
        if (!activeClassesList.includes('five-sat')) {
          activeClassesList.push('five-sat'); // 토
        }
      }
      if (['庚', '辛', '申', '酉'].includes(item.sky)) {
        if (!activeClassesList.includes('five-fri')) {
          activeClassesList.push('five-fri'); // 금
        }
      }
      if (['壬', '癸', '亥', '子'].includes(item.sky)) {
        if (!activeClassesList.includes('five-wed')) {
          activeClassesList.push('five-wed'); // 수
        }
      }
    }

    if (item.earth) {
      // 지지도 동일하게 확인
      if (['甲', '乙', '寅', '卯'].includes(item.earth)) {
        if (!activeClassesList.includes('five-thu')) {
          activeClassesList.push('five-thu'); // 목
        }
      }
      if (['丙', '丁', '巳', '午'].includes(item.earth)) {
        if (!activeClassesList.includes('five-tue')) {
          activeClassesList.push('five-tue'); // 화
        }
      }
      if (['戊', '己', '辰', '戌', '丑', '未'].includes(item.earth)) {
        if (!activeClassesList.includes('five-sat')) {
          activeClassesList.push('five-sat'); // 토
        }
      }
      if (['庚', '辛', '申', '酉'].includes(item.earth)) {
        if (!activeClassesList.includes('five-fri')) {
          activeClassesList.push('five-fri'); // 금
        }
      }
      if (['壬', '癸', '亥', '子'].includes(item.earth)) {
        if (!activeClassesList.includes('five-wed')) {
          activeClassesList.push('five-wed'); // 수
        }
      }
    }
  });

  return activeClassesList;
};

// 두 번째 탭에서 바로 배경색을 보여주기 위한 함수
const getSecondTabActiveClasses = () => {
  const result = getActiveClassesFromData();
  console.log('🔍 두 번째 탭 활성화 클래스:', result);
  return result;
};

const changeClass = () => {
  // 항상 five-thu부터 five-wed까지 순차적으로 진행
  currentClass.value = classes[index];
  currentStep.value = index + 1; // 1부터 시작하는 단계 번호

  // birthDataSkyEarth에서 매칭되는 클래스들을 확인하여 activeClasses에 추가
  const activeClassesList = getActiveClassesFromData();

  // 현재 클래스가 매칭되는 클래스 목록에 있으면 activeClasses에 추가 (유지)
  if (activeClassesList.includes(classes[index])) {
    if (!activeClasses.value.includes(classes[index])) {
      activeClasses.value.push(classes[index]);
    }
  }

  index++;

  // 모든 단계가 끝나면 애니메이션을 멈춤
  if (index >= classes.length) {
    console.log('🏁 애니메이션 완료 - 최종 activeClasses:', activeClasses.value);
    stopAnimation();
  }
};

const startAnimation = (speed = 1000) => {
  // 기존 애니메이션이 실행 중이면 먼저 정지
  if (intervalId) {
    stopAnimation();
  }

  console.log('🚀 startAnimation 시작, 속도:', speed + 'ms');
  index = 0; // 인덱스 초기화
  currentClass.value = ''; // 이전 클래스 초기화
  activeClasses.value = []; // 활성화된 클래스들 초기화
  currentStep.value = 0; // 단계 초기화
  isAnimating.value = true; // 애니메이션 시작
  changeClass(); // 처음 클래스 변경
  intervalId = setInterval(changeClass, speed); // 지정된 속도로 클래스 변경
};

const stopAnimation = () => {
  clearInterval(intervalId); // 애니메이션 중지
  intervalId = null; // interval ID 초기화
  index = 0; // 인덱스 초기화
  isAnimating.value = false; // 애니메이션 종료
  //currentClass.value = [] // 클래스 배열 초기화
};

const sajuData = ref(null);
const birthDataSkyEarth = ref(null);
const sajugangiKorArray = ref(null);

// langMode 변경 처리 함수
const handleLangModeUpdate = (mode) => {
  emit('updateLangMode', mode);
};

// emit 정의
const emit = defineEmits(['updateLangMode']);

onMounted(async () => {
  sajuData.value = await getDetail(props.guestUserId);
  birthDataSkyEarth.value = await splitToSkyEarth(sajuData?.value?.sajugangi);
  sajugangiKorArray.value = await splitToSkyEarthKor(sajuData?.value?.sajupaljaKor);

  // 각 탭에 맞는 속도로 애니메이션 시작
  if (props.selectedDescNavSub === 'first') {
    startAnimation(1000); // 1초
  } else if (props.selectedDescNavSub === 'third' || props.selectedDescNavSub === 'fourth') {
    startAnimation(0); // 즉시 모든 오행 활성화
  }
});

// selectedDescNavSub 변경 감지
watch(
  () => props.selectedDescNavSub,
  (newValue, oldValue) => {
    // 각 탭에 맞는 속도로 애니메이션 실행
    if (newValue === 'first') {
      startAnimation(1000); // 1초
    } else if (newValue === 'third' || newValue === 'fourth') {
      startAnimation(0); // 즉시 모든 오행 활성화
    } else {
      // fifth 탭이나 다른 탭으로 변경되면 애니메이션 정지
      stopAnimation();
    }
  },
);

/*
/ CSS에서 확인된 매칭:
five-back01 → TUE (화) → five-tue
five-back02 → WED (수) → five-wed  
five-back03 → THU (목) → five-thu
five-back04 → FRI (금) → five-fri
five-back05 → SAT (토) → five-sat*/
</script>

<template>
  <div class="ani-btn-section" v-if="selectedDescNavSub === 'first'">
    <button class="btn white" @click="stopAnimation"><IconPause />정지</button>
    <button class="btn white" @click="stopAnimation"><IconStop />정지</button>
    <button class="btn orange" @click="startAnimation"><IconStart />시작</button>
  </div>

  <div
    v-if="selectedDescNavSub === 'first'"
    class="chart-section full-height full-center five-round-bg pos-first"
    :class="[currentClass, ...activeClasses]"
  >
    <div class="step-bar">
      <div
        class="sp-line first"
        :class="{
          active:
            activeClasses.includes('five-thu') ||
            activeClasses.includes('five-tue') ||
            activeClasses.includes('five-sat') ||
            activeClasses.includes('five-fri') ||
            activeClasses.includes('five-wed') ||
            activeClasses.includes('finishendend'),
        }"
      >
        <div
          class="icon-arrow"
          :class="{
            active: activeClasses.includes('five-thu') || activeClasses.includes('finishend'),
          }"
        >
          <IconArrow05 />
          <span class="txt">목</span>
        </div>
      </div>
      <div
        class="sp-line"
        :class="{
          active:
            activeClasses.includes('five-tue') ||
            activeClasses.includes('five-sat') ||
            activeClasses.includes('five-fri') ||
            activeClasses.includes('five-wed') ||
            activeClasses.includes('finishendend'),
        }"
      >
        <div
          class="icon-arrow"
          :class="{
            active: activeClasses.includes('five-tue') || activeClasses.includes('finishendend'),
          }"
        >
          <IconArrow05 /><span class="txt">화</span>
        </div>
      </div>
      <div
        class="sp-line"
        :class="{
          active:
            activeClasses.includes('five-sat') ||
            activeClasses.includes('five-fri') ||
            activeClasses.includes('five-wed') ||
            activeClasses.includes('finishendend'),
        }"
      >
        <div
          class="icon-arrow"
          :class="{
            active: activeClasses.includes('five-sat') || activeClasses.includes('finishendend'),
          }"
        >
          <IconArrow05 /><span class="txt">토</span>
        </div>
      </div>
      <div
        class="sp-line"
        :class="{
          active:
            activeClasses.includes('five-fri') ||
            activeClasses.includes('five-wed') ||
            currentClass === 'finishendend',
        }"
      >
        <div
          class="icon-arrow"
          :class="{
            active: currentClass === 'five-fri' || currentClass === 'finishendend',
          }"
        >
          <IconArrow05 /><span class="txt">금</span>
        </div>
      </div>
      <div
        class="sp-line last"
        :class="{
          active: activeClasses.includes('five-wed') || activeClasses.includes('finishendend'),
        }"
      >
        <div
          class="icon-arrow"
          :class="{
            active: activeClasses.includes('five-wed') || activeClasses.includes('finishendend'),
          }"
        >
          <IconArrow05 /><span class="txt">수</span>
        </div>
      </div>
    </div>

    <FiveStartMyComponent
      ref="starRef"
      :birthData="birthData"
      :birthEightTxt="birthEightTxt"
      :rootPage="rootPage"
      :rootFiveClass="currentClass"
      :birthDataSkyEarth="birthDataSkyEarth"
      :selectedDescNavSub="selectedDescNavSub"
      :currentStep="currentStep"
      :totalSteps="totalSteps"
      :isAnimating="isAnimating"
      :langMode="props.langMode"
      @skyDay-click="handleSkyDayClick"
      @skyDay-reset="resetSkyDay"
      @open-ilgan="openIlgan"
      @close-ilgan="closePopIlgan()"
      @openPopFiveStar="openPopFiveStar"
      @closePopFiveStar="closePopFiveStar"
      @clickIlganButton="clickIlganButton"
    />
  </div>
  <div
    v-if="
      selectedDescNavSub === 'third' ||
      selectedDescNavSub === 'fourth' ||
      selectedDescNavSub === 'fifth'
    "
    class="chart-chart-section full-height full-center five-round-bg five-tab-second"
    :class="[selectedDescNavSub, ...getSecondTabActiveClasses()]"
  >
    <FiveStartMyComponent
      ref="starRef"
      :birthData="birthData"
      :birthEightTxt="birthEightTxt"
      :rootPage="rootPage"
      :rootFiveClass="currentClass"
      :birthDataSkyEarth="birthDataSkyEarth"
      :selectedDescNavSub="selectedDescNavSub"
      :currentStep="currentStep"
      :totalSteps="totalSteps"
      :isAnimating="isAnimating"
      :langMode="props.langMode"
      @skyDay-click="handleSkyDayClick"
      @skyDay-reset="resetSkyDay"
      @open-ilgan="openIlgan"
      @close-ilgan="closePopIlgan()"
      @openPopFiveStar="openPopFiveStar"
      @closePopFiveStar="closePopFiveStar"
      @clickIlganButton="clickIlganButton"
    />
  </div>
</template>
<style lang="scss">
@import '/src/assets/nangman_style/personality.scss';

.finishendend .pro-star-box.myfive-box {
  background-image: url('@manseImages/five/full_shape.svg');
}

.third .pro-star-box.myfive-box,
.fourth .pro-star-box.myfive-box,
.fifth .pro-star-box.myfive-box {
  background-image: url('@manseImages/five/full_shape.svg');
}

.pro-star-box.myfive-box {
  .div-back {
    &.active {
      opacity: 1 !important;
    }
  }
  .div-txt {
    &.active {
      color: #fff !important;
    }
  }
}

.div-back.five-back03.st-back-thu {
  background-image: url('@manseImages/five/full_shape_five03.png');
}
.div-back.five-back01.st-back-tue {
  background-image: url('@manseImages/five/full_shape_five01.png');
}
.div-back.five-back05.st-back-sat {
  background-image: url('@manseImages/five/full_shape_five05.png');
}
.div-back.five-back04.st-back-fri {
  background-image: url('@manseImages/five/full_shape_five04.png');
}
.div-back.five-back02.st-back-wed {
  background-image: url('@manseImages/five/full_shape_five02.png');
}

/* 오행 그라데이션 믹스인 */
@mixin gradient($color1, $color2, $color3, $color4, $color5, $color6) {
  background-color: transparent !important;
  background-image: conic-gradient(
    $color1 0deg 36deg,
    $color2 36deg 116deg,
    $color3 116deg 180deg,
    $color4 180deg 243deg,
    $color5 243deg 324deg,
    $color6 288deg 0deg
  ) !important;
  background-blend-mode: multiply !important;
}

.five-round-bg {
  background-color: #fff !important;
  background-image: none !important;

  /* 개별 클래스 정의 (목-화-토-금-수 순서) */
  &.five-thu {
    @include gradient(#fff, #fff, #fff, #f6faf2, #fff, #fff);
  }
  &.five-tue {
    @include gradient(#fff, #fff, #fff, #fff, #fcf3f3, #fff);
  }
  &.five-sat {
    @include gradient(#fdf9f2, #fff, #fff, #fff, #fff, #fdf9f2);
  }
  &.five-fri {
    @include gradient(#fff, #f9f9f9, #fff, #fff, #fff, #fff);
  }
  &.five-wed {
    @include gradient(#fff, #fff, #f4f4f4, #fff, #fff, #fff);
  }

  /* 두 개 조합 */
  &.five-thu.five-tue {
    @include gradient(#fff, #fff, #fff, #f6faf2, #fcf3f3, #fff);
  }
  &.five-thu.five-wed {
    @include gradient(#fff, #fff, #f4f4f4, #f6faf2, #fff, #fff);
  }
  &.five-thu.five-fri {
    @include gradient(#fff, #f9f9f9, #fff, #f6faf2, #fff, #fff);
  }
  &.five-thu.five-sat {
    @include gradient(#fdf9f2, #fff, #fff, #f6faf2, #fff, #fdf9f2);
  }
  &.five-tue.five-wed {
    @include gradient(#fff, #fff, #f4f4f4, #fff, #fcf3f3, #fff);
  }
  &.five-tue.five-fri {
    @include gradient(#fff, #f9f9f9, #fff, #fff, #fcf3f3, #fff);
  }
  &.five-tue.five-sat {
    @include gradient(#fdf9f2, #fff, #fff, #fff, #fcf3f3, #fdf9f2);
  }
  &.five-wed.five-fri {
    @include gradient(#fff, #f9f9f9, #f4f4f4, #fff, #fff, #fff);
  }
  &.five-wed.five-sat {
    @include gradient(#fdf9f2, #fff, #f4f4f4, #fff, #fff, #fdf9f2);
  }
  &.five-fri.five-sat {
    @include gradient(#fdf9f2, #f9f9f9, #fff, #fff, #fff, #fdf9f2);
  }

  /* 세 개 조합 */
  &.five-thu.five-tue.five-wed {
    @include gradient(#fff, #fff, #f4f4f4, #f6faf2, #fcf3f3, #fff);
  }
  &.five-thu.five-tue.five-fri {
    @include gradient(#fff, #f9f9f9, #fff, #f6faf2, #fcf3f3, #fff);
  }
  &.five-thu.five-tue.five-sat {
    @include gradient(#fdf9f2, #fff, #fff, #f6faf2, #fcf3f3, #fdf9f2);
  }
  &.five-thu.five-wed.five-fri {
    @include gradient(#fff, #f9f9f9, #f4f4f4, #f6faf2, #fff, #fff);
  }
  &.five-thu.five-wed.five-sat {
    @include gradient(#fdf9f2, #fff, #f4f4f4, #f6faf2, #fff, #fdf9f2);
  }
  &.five-thu.five-fri.five-sat {
    @include gradient(#fdf9f2, #f9f9f9, #fff, #f6faf2, #fff, #fdf9f2);
  }
  &.five-tue.five-wed.five-fri {
    @include gradient(#fff, #f9f9f9, #f4f4f4, #fff, #fcf3f3, #fff);
  }
  &.five-tue.five-wed.five-sat {
    @include gradient(#fdf9f2, #fff, #f4f4f4, #fff, #fcf3f3, #fdf9f2);
  }
  &.five-tue.five-fri.five-sat {
    @include gradient(#fdf9f2, #f9f9f9, #fff, #fff, #fcf3f3, #fdf9f2);
  }
  &.five-wed.five-fri.five-sat {
    @include gradient(#fdf9f2, #f9f9f9, #f4f4f4, #fff, #fff, #fdf9f2);
  }

  /* 네 개 조합 */
  &.five-thu.five-tue.five-wed.five-fri {
    @include gradient(#fff, #f9f9f9, #f4f4f4, #f6faf2, #fcf3f3, #fff);
  }
  &.five-thu.five-tue.five-wed.five-sat {
    @include gradient(#fdf9f2, #fff, #f4f4f4, #f6faf2, #fcf3f3, #fdf9f2);
  }
  &.five-thu.five-tue.five-fri.five-sat {
    @include gradient(#fdf9f2, #f9f9f9, #fff, #f6faf2, #fcf3f3, #fdf9f2);
  }
  &.five-thu.five-wed.five-fri.five-sat {
    @include gradient(#fdf9f2, #f9f9f9, #f4f4f4, #f6faf2, #fff, #fdf9f2);
  }
  &.five-tue.five-wed.five-fri.five-sat {
    @include gradient(#fdf9f2, #f9f9f9, #f4f4f4, #fff, #fcf3f3, #fdf9f2);
  }

  /* 모든 조합 */
  &.five-thu.five-tue.five-wed.five-fri.five-sat {
    @include gradient(#fdf9f2, #f9f9f9, #f4f4f4, #f6faf2, #fcf3f3, #fdf9f2);
  }
}
/* .fifth 탭일 때는 요일별 스타일을 무시하고 단순 그라데이션 적용 */
.five-round-bg.fifth,
.five-round-bg.fifth.five-thu,
.five-round-bg.fifth.five-tue,
.five-round-bg.fifth.five-wed,
.five-round-bg.fifth.five-fri,
.five-round-bg.fifth.five-sat,
.five-round-bg.fifth.five-thu.five-tue,
.five-round-bg.fifth.five-thu.five-wed,
.five-round-bg.fifth.five-thu.five-fri,
.five-round-bg.fifth.five-thu.five-sat,
.five-round-bg.fifth.five-tue.five-wed,
.five-round-bg.fifth.five-tue.five-fri,
.five-round-bg.fifth.five-tue.five-sat,
.five-round-bg.fifth.five-wed.five-fri,
.five-round-bg.fifth.five-wed.five-sat,
.five-round-bg.fifth.five-fri.five-sat,
.five-round-bg.fifth.five-thu.five-tue.five-wed,
.five-round-bg.fifth.five-thu.five-tue.five-fri,
.five-round-bg.fifth.five-thu.five-tue.five-sat,
.five-round-bg.fifth.five-thu.five-wed.five-fri,
.five-round-bg.fifth.five-thu.five-wed.five-sat,
.five-round-bg.fifth.five-thu.five-fri.five-sat,
.five-round-bg.fifth.five-tue.five-wed.five-fri,
.five-round-bg.fifth.five-tue.five-wed.five-sat,
.five-round-bg.fifth.five-tue.five-fri.five-sat,
.five-round-bg.fifth.five-wed.five-fri.five-sat,
.five-round-bg.fifth.five-thu.five-tue.five-wed.five-fri,
.five-round-bg.fifth.five-thu.five-tue.five-wed.five-sat,
.five-round-bg.fifth.five-thu.five-tue.five-fri.five-sat,
.five-round-bg.fifth.five-thu.five-wed.five-fri.five-sat,
.five-round-bg.fifth.five-tue.five-wed.five-fri.five-sat,
.five-round-bg.fifth.five-thu.five-tue.five-wed.five-fri.five-sat {
  background-image: linear-gradient(to right, #f7f7f7 50%, #eeeeee 50%) !important;
}

.pro-star-box.myfive-box .txt-five-box.st-05 .txt-top .al-left-box {
  right: 50.43%;
}
.pro-star-box.myfive-box .txt-five-box.st-05 .txt-top .al-right-box {
  left: 50.43%;
}
</style>
